import { TermsDialog } from "@/components/TermsDialog";
import { InstallDialog } from "@/components/InstallDialog";
import { GlossaryDialog } from "@/components/GlossaryDialog";
import { AlertTriangle } from "lucide-react";

export function SiteFooter() {
  return (
    <footer data-testid="site-footer" className="max-w-3xl mx-auto px-4 mt-8 pt-5 border-t border-white/10 text-xs sm:text-sm text-[#6B7280] leading-relaxed">
      <p className="flex items-start gap-2">
        <AlertTriangle size={14} className="text-[#F59E0B] mt-0.5 shrink-0" />
        <span>
          <span className="text-[#9CA3AF] font-medium">Risk disclaimer:</span> XAUUSD AI Terminal provides AI-generated analysis for educational
          purposes only and is not financial advice. Trading gold involves substantial risk of loss; past performance does not guarantee
          future results. You are solely responsible for your trading decisions.
        </span>
      </p>
      <div className="mt-3 flex items-center gap-3">
        <span>© {new Date().getFullYear()} XAUUSD AI Terminal</span>
        <span>·</span>
        <TermsDialog trigger={
          <button data-testid="footer-terms-link" className="text-[#F59E0B] hover:underline underline-offset-2">Terms & Disclaimer</button>
        } />
        <span>·</span>
        <GlossaryDialog trigger={
          <button data-testid="footer-glossary-link" className="text-[#F59E0B] hover:underline underline-offset-2">Plain-English Guide</button>
        } />
        <span>·</span>
        <InstallDialog trigger={
          <button data-testid="footer-install-link" className="text-[#F59E0B] hover:underline underline-offset-2">Install on phone</button>
        } />
      </div>
    </footer>
  );
}
